import React from 'react';
import {
  getArrayOfLastThirtyDays,
  getSimpleDateFromISOString, makeDateURLSafe,
} from '../../../utils/dateFunctions';

export default function CustomCalendar({ typeDays, origType, typeId, amountData }) {
  const thirtyDays = getArrayOfLastThirtyDays();

  let simpleDate = '';
  let foundIndex = 0;

  let searchDate = '';

  thirtyDays.forEach((vol) => {
    vol.opacity = 0.2;
    vol.volume = 0;
  });

  typeDays.length > 0 && thirtyDays.length > 0 && thirtyDays.forEach((data, index) => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();

    simpleDate = getSimpleDateFromISOString(data);
    foundIndex = typeDays.findIndex(elem => elem === simpleDate);
    if (foundIndex >= 0) {
      thirtyDays[index]['opacity'] = 1;
    } else if (data <= new Date(year, month, day - 30)) {
      thirtyDays[index]['opacity'] = 0;
    } else {
      thirtyDays[index]['opacity'] = 0.2;
    }
  });


  amountData.length > 0 && thirtyDays.length > 0 && amountData.forEach((data, index) => {
    searchDate = data.dateTime.slice(0, 10).replaceAll('-', '/');

    thirtyDays.forEach((data2, index2) => {
      simpleDate = getSimpleDateFromISOString(data2);
      if (searchDate === simpleDate) {
        if (data.activeAmount > 0) {
          data2.volume += Number(data.activeAmount);
        }
      }
    });
  });

  /*  typeDays.length === 0 && thirtyDays.forEach((data, index) => {
      thirtyDays[index]['opacity'] = 0.2;
    });*/

  return (
    <>
      <ul style={{ width: 800 }} id={'30days'}>
        {thirtyDays.map((data, i) => {
          return (
            <li key={data} style={{
              display: 'inline-block',
              border: '1px black solid',
              margin: 5,
              padding: 5,
              width: 80,
              height: 80,
              backgroundColor: 'blue',
              opacity: data.opacity,
              color: 'grey',
            }}>{data.opacity === 1 ? (
              <a href={'/type/' + typeId + '/date/' + makeDateURLSafe(getSimpleDateFromISOString(data))}
                 style={{ color: 'white' }}>{data.toDateString()}</a>) : (data.toDateString())
            }
              {data.volume > 0 ? (
                <p style={{
                  color: 'red',
                  fontSize: 24,
                  padding: '10px 0 0 0',
                  margin: 0,
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}>{data.volume}</p>
              ) : <p style={{ color: 'red', fontSize: 24, padding: '10px 0 0 0', margin: 0 }}>&nbsp;</p>}
            </li>
          );
        })}

        <h2>Days with {origType.name} Readings</h2>
        <ul>
          {typeDays.length > 0 && typeDays.map((reading) => {
            return (
              <li key={reading}>
                <a href={'/type/' + typeId + '/date/' + makeDateURLSafe(reading)}>
                  {reading}
                </a>
              </li>
            );
          })}
        </ul>

      </ul>
    </>);
}